import {on, findAllIn, findIn, removeClass, removeAttribute, addClass, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import TerracePlanner from "./index";
import {switchTab, unCompleteTab} from "./tabManager";
import Modal from "bootstrap/js/dist/modal";

let backendUrl = window.location.protocol + '//' + window.location.hostname + '/r/terraceplanner/subsidiary/',
    localStorageSubsidiary = 'terracePlannerTemporarySubsidiary',
    localStorageSubsidiaryName = 'terracePlannerTemporarySubsidiaryName',
    subsidiary,
    subsidiaryName,
    modalNode,
    modalContentLoaded = false,
    subsidiaryNameNode;

/**
 * initializes the module, binds eventListeners, loads panels if they are already complete
 *
 * @param initialTabData Anything | Object
 */
export function init (initialTabData) {
    if (TerracePlanner.loggedIn) {
        return;
    }

    modalNode = findIn('#subsidiarySelection', TerracePlanner.element);
    subsidiaryNameNode = findIn('#selectedSubsidiaryName', TerracePlanner.element);

    TerracePlanner.selectedSubsidiary = localStorage.getItem(localStorageSubsidiary) || null;
    TerracePlanner.selectedSubsidiaryName = localStorage.getItem(localStorageSubsidiaryName) || '';

    subsidiary = TerracePlanner.selectedSubsidiary;
    subsidiaryName = TerracePlanner.selectedSubsidiaryName;

    if(subsidiary === null) {
        if (modalContentLoaded !== true) {
            loadModalContent();
        } else {
            toggleModal(true);
        }
    } else {
        if (modalContentLoaded !== true) {
            loadModalContent(true);
        }
    }

    subsidiaryNameNode.innerHTML = subsidiaryName;

    if (!modalContentLoaded) {
        on('show.bs.modal', () => {
            loadModalContent();
        }, modalNode);
    }
}

/**
 * sends an xhr to the backend to save the selected GB in the session,
 * also saves the selection to localStorage
 *
 * @param gb String
 * @param callback Function (Object) -> void
 */
function selectSubsidiary(gb, keepCurrentStep) {
    subsidiary = gb || subsidiary;

    localStorage.setItem(localStorageSubsidiary, subsidiary);

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'select?gb=' + gb,
        responseType: 'json'
    }).then((data) => {
        toggleModal(false);

        if (!keepCurrentStep) {
            unCompleteTab('surface');
            unCompleteTab('subStructure');
            unCompleteTab('product');
            unCompleteTab('plankPattern');
            unCompleteTab('summary');

            switchTab('outline', false, true);
        }
    });
}

/**
 * returns whether there is already a subsidiary selected
 *
 * @returns {boolean}
 */
function hasSubsidiary() {
    return null !== subsidiary;
}

/**
 * fetches an HTML view from the backend to paste into modalNode
 */
function loadModalContent (active) {
    removeAttribute('hidden', findIn('.js-dynamic-modal__loading', TerracePlanner.element))

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'get-available',
        responseType: 'json'
    }).then((data) => {
        modalContentLoaded = true;

        findIn('.js-dynamic-modal__content', modalNode).innerHTML = data.data;

        if (active) {
            activateSubsidiary(subsidiary, subsidiaryName);
            selectSubsidiary(subsidiary, true);
        }

        let subsidiaries = findAllIn('.js-planner__subsidiary-select', TerracePlanner.element);

        subsidiaries.map((subsidiary) => {
            on('click', () => {
                selectionListener(subsidiary);
            }, subsidiary);
        });

        if(1 === subsidiaries.length) {
            selectionListener(subsidiaries[0])
        } else {
            if (!active) {
                toggleModal(true);
            }
        }

        setAttribute('hidden', true, findIn('.js-dynamic-modal__loading', TerracePlanner.element))
    });
}

/**
 * opens or closes modalNode
 *
 * @param open Boolean
 */
function toggleModal (open) {
    let modalInstance = Modal.getOrCreateInstance(modalNode);

    if(open) {
        modalInstance.show();
    } else {
        modalInstance.hide();
    }
}


/**
 * sets an 'active' class to a table row in the modal and remove that class from the currently active one
 * displays the selected subsidiary's name in subsidiaryNameNode
 * and saves that name to localStorage
 *
 * @param id String
 * @param name String
 */
function activateSubsidiary(id, name) {
    if (findIn('.js-planner__subsidiary-select.is-active', TerracePlanner.element)) {
        removeClass('is-active', findIn('.js-planner__subsidiary-select.is-active', TerracePlanner.element));
    }
    addClass('is-active', findIn('.js-planner__subsidiary-select[data-gb="' + id + '"]', TerracePlanner.element));

    subsidiaryNameNode.innerHTML = name;

    localStorage.setItem(localStorageSubsidiaryName, name);
}

/**
 * listener to select a subsidiary from modalNode
 *
 * @param event MouseEvent
 */
function selectionListener(target) {
    let gb = target.getAttribute('data-gb');
    let name = target.getAttribute('data-name');

    activateSubsidiary(gb, name);
    selectSubsidiary(gb);
}